module.exports = __webpack_public_path__ + "static/media/externalBarn_8.896abe99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn/externalBarn_8.png
// module id = 1312
// module chunks = 3